import React, { useState, useRef, useEffect } from 'react';
import classNames from 'classnames';
import { hookUtils } from '@indico-data/utils';
import { Button } from 'Permafrost/index';
import { Icon } from 'Permafrost/index';
import { StyledFilterSelect } from './FilterSelect.styles';
import { isEqual } from 'lodash';
import { FilterSelectControls, FilterSelectOptions, FilterSelectReset } from './components';
import { sortOptionsList } from './helpers';
export const FilterSelect = ({ isMulti = false, label, optionsList, placement = 'right', selected, onSave, }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [selectedFilters, setSelectedFilters] = useState([]);
    const menuEl = useRef();
    const hasSelected = (selectedFilters === null || selectedFilters === void 0 ? void 0 : selectedFilters.length) > 0;
    const handleToggleMultiFilter = (option) => {
        if (selectedFilters === null || selectedFilters === void 0 ? void 0 : selectedFilters.some((filterOption) => isEqual(filterOption.value, option.value))) {
            setSelectedFilters(selectedFilters === null || selectedFilters === void 0 ? void 0 : selectedFilters.filter((filterOption) => !isEqual(filterOption.value, option.value)));
        }
        else {
            setSelectedFilters([...selectedFilters, option]);
        }
    };
    const handleToggleSingleFilter = (option) => {
        isEqual(selectedFilters === null || selectedFilters === void 0 ? void 0 : selectedFilters[0], option) && hasSelected
            ? setSelectedFilters([])
            : setSelectedFilters([option]);
    };
    const handleOptionClick = (option) => {
        isMulti ? handleToggleMultiFilter(option) : handleToggleSingleFilter(option);
    };
    hookUtils.useClickOutside(menuEl, () => {
        if (isOpen) {
            setSelectedFilters(selected ? selected : []);
            setIsOpen(false);
        }
    });
    // ensures local state of selectedFilters is updated when selected prop is changed
    useEffect(() => {
        if (selected && selected !== selectedFilters)
            setSelectedFilters(selected);
    }, [selected]);
    return (React.createElement(StyledFilterSelect, { ref: menuEl, "$placement": placement, className: "filter" },
        React.createElement(Button, { className: classNames('FilterSelect__toggle', 'square', {
                'filters-on': hasSelected,
            }), "data-testid": "toggle-btn", onClick: () => {
                setIsOpen(!isOpen);
            } },
            label ? React.createElement("span", { className: "filter-label" }, label) : null,
            React.createElement(Icon, { name: label ? 'fa-caret-down' : 'filter' }),
            hasSelected ? React.createElement("span", { className: "swatch-circle" }) : []),
        React.createElement("div", { "data-testid": "div-filter-options-container", className: classNames('filter__container', {
                visible: isOpen,
            }) },
            React.createElement("div", { className: "FilterSelect__options" },
                React.createElement(FilterSelectOptions, { isMulti: isMulti, optionsList: sortOptionsList(optionsList, selected), selectedFilters: selectedFilters, handleOptionClick: handleOptionClick }),
                React.createElement(FilterSelectReset, { selectedFilterCount: selectedFilters.length, setSelectedFilters: setSelectedFilters })),
            React.createElement(FilterSelectControls, { currentStoreFilters: selected, selectedFilters: selectedFilters, onSave: onSave, setIsOpen: setIsOpen, setSelectedFilters: setSelectedFilters }))));
};
//# sourceMappingURL=FilterSelect.js.map